import Picture from 'components/picture';

export const Image = Picture.withConfig({ width: '$10', height: '$10' });
